import * as React from 'react';
import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import { token } from '@atlaskit/tokens';

interface SearchResultBaseProps {
    title: React.ReactNode;
    helperText: React.ReactNode;
    imageSrc: string;
    className?: string;
}

const SearchResultBase: React.StatelessComponent<SearchResultBaseProps> = ({
    title,
    helperText,
    imageSrc,
    ...props
}) => (
    <Root {...props}>
        {/* eslint-disable-next-line styled-components-a11y/alt-text */}
        <Img src={imageSrc} />
        <Title>{title}</Title>
        <HelperText>{helperText}</HelperText>
    </Root>
);

export default SearchResultBase;

const Root = styled.div`
    max-width: ${grid.multiple(70).px};
    padding: ${token('space.400', '32px')} ${token('space.100', '8px')} ${token('space.100', '8px')}
        ${token('space.100', '8px')};
`;

const Title = styled.div`
    text-align: center;
    font-weight: bold;
    padding: ${token('space.200', '16px')} 0;
`;

const HelperText = styled.div`
    text-align: center;
`;

const Img = styled.img`
    width: ${grid.multiple(13).px};
    height: ${grid.multiple(10).px};
    margin: 0 auto;
    display: block;
    padding: ${token('space.200', '16px')};
`;
